import styled from "styled-components";

export const Grid = styled.div`
    display: grid;
    border-radius: 40px;
    background-color: #ffffff;
    width: 60vw;
    margin: 30px auto;
    padding: 40px 40px 90px 40px;
    @media (max-width: 1480px) {
        width: 80vw;
    }
    @media (max-width: 1240px) {
        width: 95vw;
    }
`;

export const Title = styled.h3`
    font-weight: 600;
    font-size: 48px;
    color: #082e99;
    line-height: 153%;
    margin: 45px 5px 30px 0;
    max-width: 90%;
`;

export const Text = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    margin: 0;
    max-width: 90%;
    color: rgba(0, 0, 0, 0.85);
`;

export const Logo = styled.img`
    margin-top: 72px;
    margin-bottom: 42px;
    height: 42px;
`;
